/* @flow */
const prefix = str => `station/redaction/${str}`;

export const SET_CURRENT_CATEGORY_ID = prefix('SET_CURRENT_CATEGORY_ID');

export const FETCH = prefix('FETCH');
export const FETCH_SUCCESS = prefix('FETCH_SUCCESS');
export const FETCH_FAILURE = prefix('FETCH_FAILURE');

export const FETCH_SHARED_LIBRARY = prefix('FETCH_SHARED_LIBRARY');

export const ADD_TERM_LOCAL = prefix('ADD_TERM_LOCAL');
export const ADD_TERM_SHARED = prefix('ADD_TERM_SHARED');

export const SAVE = prefix('SAVE');
export const SAVE_SUCCESS = prefix('SAVE_SUCCESS');
export const SAVE_FAILURE = prefix('SAVE_FAILURE');

export const DELETE_TERM_LOCAL = prefix('DELETE_TERM_LOCAL');
export const DELETE_TERM_SHARED = prefix('DELETE_TERM_SHARED');

export const DELETE = prefix('DELETE');
export const DELETE_SUCCESS = prefix('DELETE_SUCCESS');
export const DELETE_FAILURE = prefix('DELETE_FAILURE');

export const UPLOAD_REDACTION_FILE = prefix('UPLOAD_REDACTION_FILE');
export const BULK_ADD_TERMS = prefix('BULK_ADD_TERMS');

export const BULK_SAVE_TERMS_LOCAL = prefix('BULK_SAVE_TERMS_LOCAL');
export const BULK_SAVE_TERMS_SHARED = prefix('BULK_SAVE_TERMS_SHARED');

export const BULK_SAVE = prefix('BULK_SAVE');
export const BULK_SAVE_SUCCESS = prefix('BULK_SAVE_SUCCESS');
export const BULK_SAVE_FAILURE = prefix('BULK_SAVE_FAILURE');

// Redactables
export const FETCH_REDACTABLES = prefix('FETCH_REDACTABLES');
export const FETCH_REDACTABLES_SUCCESS = prefix('FETCH_REDACTABLES_SUCCESS');
export const FETCH_REDACTABLES_FAILURE = prefix('FETCH_REDACTABLES_FAILURE');

export const CLEAR_REDACTABLES = prefix('CLEAR_REDACTABLES');



// WEBPACK FOOTER //
// ./src/app/modules/redaction/action-types.js